import { Component, EventEmitter, HostListener, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'spinner-button',
  templateUrl: './spinner-button.component.html',
  styleUrls: ['./spinner-button.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SpinnerButtonComponent {
  @Input()
  public pending: boolean;

  @Input()
  public disabled: boolean;

  @Input()
  public type: string;

  @Input()
  public autId?: string;

  @Output()
  public clicked = new EventEmitter<MouseEvent>();

  public get buttonType(): string {
    return this.disabled || this.pending ? 'button' : this.type;
  }

  constructor() {
    this.type = 'submit';
  }

  @HostListener('click', ['$event'])
  public onClick(e: MouseEvent): void {
    e.stopPropagation();

    if (!this.disabled) {
      this.clicked.emit(e);
    }
  }
}
